// ======================================================================
// File Name       : UserSearchOnDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { reduxForm, isInvalid, change } from 'redux-form';
import { connect } from 'react-redux';
import { Form, Col, Button } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import ReduxFormPaging from '../ReduxFormPaging';
import SelectGroupDialog from '../SelectGroupDialog';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import { USER_ATTRIBUTE_KEY_NUM_LIST } from '../../constants/UserAttributeConstants';
import CustomButton from '../button/CustomButton';

class UserSearchOnDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.showSelectGroupDialog = this.showSelectGroupDialog.bind(this);
    this.closeSelectGroupDialog = this.closeSelectGroupDialog.bind(this);
  }

  showSelectGroupDialog() {
    this.props.dispatch(
      change('searchUserForm', 'selectedTargetGroup', this.props.selectedTargetGroup),
    );
    this.setState({
      show: true,
    });
  }

  closeSelectGroupDialog() {
    this.setState({
      show: false,
    });
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.props.onSearchBtnClick(0);
  }

  render() {
    const {
      groupList,
      selectedTargetGroup,
      withAuthority,
      managementAuthorityList,
      managementAuthoritySecernId,
      withUserAttribute,
      userAttributeKeyNum,
      withGroup,
      withSelectAll,
      checkUncheckAllUsersOnPage,
      singleSelect,
    } = this.props;
    let groupName = '';
    if (selectedTargetGroup && selectedTargetGroup.groupSecernId && groupList) {
      const groupSecernId = selectedTargetGroup.groupSecernId;
      groupName = convertNodeGroupToNodeString(groupSecernId, groupList);
    }
    const style = {
      height: '120%',
    };
    return (
      <div>
        <Form onSubmit={this.props.handleSubmit} className='form-horizontal'>
          {withAuthority && (
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                権限
              </Col>
              <Col sm={9}>
                <RenderField
                  type="selectbox"
                  name="managementAuthoritySecernId"
                  label="権限"
                  value={managementAuthoritySecernId}
                  data={managementAuthorityList}
                  valueKey="managementAuthoritySecernId"
                  nameKey="managementAuthorityName"
                />
              </Col>
            </Form.Group>
          )}
          <Form.Group>
            <Col as={Form.Label} sm={3} className="text-left">
              ログインID
            </Col>
            <Col sm={9}>
              <RenderField type="text" name="loginId" />
            </Col>
          </Form.Group>
          <Form.Group>
            <Col as={Form.Label} sm={3} className="text-left">
              ユーザー名
            </Col>
            <Col sm={9}>
              <RenderField type="text" name="userName" />
            </Col>
          </Form.Group>
          {withGroup && (
            <div>
              <Form.Group>
                <Col as={Form.Label} sm={3} className="text-left">
                  ユーザーグループ名
                </Col>
                <Col sm={9}>
                  <Button onClick={this.showSelectGroupDialog} variant="primary" className="btn-96">
                    グループ選択
                  </Button>
                </Col>
              </Form.Group>
              {groupName && (
              <Form.Group>
                <Col sm={3}>
                </Col>
                <Col sm={7} as={Form.Label}>{groupName}</Col>
                <Col sm={2}>
                    <Button
                      onClick={this.props.removeSelectedGroup}
                      variant="primary"
                      className="btn-96"
                    >
                      削除
                    </Button>
                  </Col>
              </Form.Group>
              )}
            </div>
          )}
          {withUserAttribute && (
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                自由記述領域
              </Col>
              <Col sm={2}>
                <RenderField
                  type="selectbox"
                  name="userAttributeKeyNum"
                  label="自由記述領域"
                  value={userAttributeKeyNum}
                  data={USER_ATTRIBUTE_KEY_NUM_LIST}
                />
              </Col>
              <Col sm={5}>
                <RenderField type="text" name="userAttributeSearchText" />
              </Col>
            </Form.Group>
          )}
          <Form.Group>
            <Col sm={12} className="text-center">
              {/* <Button
                onClick={this.props.handleSubmit(this.onSearchBtnClick)}
                bsStyle="primary"
                className="btn-96"
              >
              </Button> */}
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                handleClick={this.props.handleSubmit(this.onSearchBtnClick)}
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
          <Form.Group>
            <Col sm={12}>
              {withSelectAll && !singleSelect && (
                <Col sm={3}>
                  <Button
                    onClick={checkUncheckAllUsersOnPage}
                    className="btn-96"
                    style={{ marginTop: '20px' }}
                  >
                    全選択/解除
                  </Button>
                </Col>
              )}
            </Col>
          </Form.Group>
          {withGroup && (
            <SelectGroupDialog
              {...this.props.groupInfo}
              show={this.state.show}
              parent={this}
              showSelectGroupDialog={this.showSelectGroupDialog}
              closeSelectGroupDialog={this.closeSelectGroupDialog}
              formKey="searchUserForm"
              shouldSearchGroup={false}
              style={style}
            />
          )}
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { registerMessageThreadForm, searchUserForm } = state.form;
  const { selectedTargetGroup, structures, groupList } = state.group;
  return {
    searchUserForm,
    registerMessageThreadForm,
    selectedTargetGroup,
    groupList,
    groupInfo: structures,
    invalid: isInvalid('searchUserForm')(state),
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'searchUserForm',
    touchOnChange: true,
    enableReinitialize: true,
  })(UserSearchOnDialog),
);
